import type { PlaybookId } from "@repo/app-types/entities/playbook";
import { SimpleSelect } from "@repo/ui/Select/simpleSelect";
import type { FC, ReactNode } from "react";
import {
  buildPlaybookAndVoiceAgentSections,
  checkIsVoiceAgentOption,
  type PlaybookAndVoiceAgentOption,
} from "../hooks/usePlaybookAndVoiceAgentOptions.js";

export interface PlaybookAndVoiceAgentSelectProps {
  options: readonly PlaybookAndVoiceAgentOption[];
  value: PlaybookId | null;
  onChange: (value: PlaybookId) => void;
  label: string;
  isLabelHidden?: boolean;
  isDisabled?: boolean;
  placeholder?: ReactNode;
  disabledPlaybookIds?: readonly PlaybookId[];
  /** Render voice agents under their header but keep them unselectable. */
  areVoiceAgentsDisabled?: boolean;
}

/**
 * Single-select over the company's playbooks and voice agents, grouped under
 * "Playbook" / "Voice agent" headers. Voice agent options carry the playbook
 * backing the agent.
 */
export const PlaybookAndVoiceAgentSelect: FC<
  PlaybookAndVoiceAgentSelectProps
> = (props) => {
  const sections = buildPlaybookAndVoiceAgentSections(props.options);
  const disabledValues = [
    ...(props.disabledPlaybookIds ?? []),
    ...(props.areVoiceAgentsDisabled
      ? props.options
          .filter(checkIsVoiceAgentOption)
          .map((option) => option.value)
      : []),
  ];

  return (
    <SimpleSelect
      label={props.label}
      isLabelHidden={props.isLabelHidden}
      isDisabled={props.isDisabled}
      placeholder={props.placeholder}
      sections={sections}
      disabledValues={disabledValues}
      value={props.value}
      onChange={props.onChange}
    />
  );
};
